module.exports = __webpack_public_path__ + "img/DiaryBarham-YaktrBynin.1f8b7f9b.jpg";